import { readAuthContextAttributes } from '@/plugins/auth-context.ts';

declare global {
    interface Window {
        newrelic?: {
            addPageAction?: (actionName: string, attributes?: Record<string, unknown>) => void;
        };
    }
}

const LEAD_PAGE_ACTION = 'lead_page_painted';

let leadNavigationStart: number | null = null;
let pendingLeadId: string | undefined;
let hasReportedPaint = false;

export function startLeadPageNavigation(leadId?: string | number): void {
    leadNavigationStart = performance.now();
    pendingLeadId = leadId ? leadId.toString() : undefined;
    hasReportedPaint = false;
}

export function resetLeadPageTiming(): void {
    leadNavigationStart = null;
    pendingLeadId = undefined;
    hasReportedPaint = false;
}

export function markLeadPagePaint(leadId?: string | number): void {
    if (hasReportedPaint) {
        return;
    }

    const addPageAction = window.newrelic?.addPageAction;

    if (!addPageAction) {
        return;
    }

    const resolvedLeadId = leadId ?? pendingLeadId;
    const startedAt = leadNavigationStart ?? 0;
    const durationMs = Math.round(performance.now() - startedAt);

    addPageAction(LEAD_PAGE_ACTION, {
        durationMs,
        leadId: resolvedLeadId?.toString(),
        startedAtNavigation: leadNavigationStart !== null,
        app_version: process.env.VUE_APP_VERSION || 'unknown',
        app_build_id: process.env.VUE_APP_BUILD_ID || 'unknown',
        ...readAuthContextAttributes(),
    });

    hasReportedPaint = true;
    leadNavigationStart = null;
    pendingLeadId = undefined;
}
